import { ONE_HOUR_MS } from '@netpurpose/types'
import { useQuery } from '@tanstack/react-query'

type StrapiRelease = {
  title: string
  date: string
  slug: string
  releaseStatus: 'pending' | 'released'
  releaseNumber: number
  createdAt: string
  updatedAt: string
  publishedAt: string
}

export const useLatestRelease = () => {
  const { data, ...rest } = useQuery({
    queryKey: ['releases'],
    queryFn: async () => {
      const res = await fetch('/api/strapi/latest-release', {
        method: 'GET',
      })
      if (!res.ok) {
        throw new Error(`Failed to fetch Strapi data: ${res.statusText}`)
      }
      return res.json()
    },
    staleTime: ONE_HOUR_MS,
  })

  return {
    release: data as StrapiRelease,
    ...rest,
  }
}
